import { OgpCompanyType } from '@types';

export const isLimitedOgpCompany = (companyType: OgpCompanyType | undefined): boolean =>
  companyType === 'LIMITED';
